import { Box, HStack, Icon, Image, Text } from "@chakra-ui/react";
import { RiInstanceLine } from "@remixicon/react";
import { useNavigate } from "react-router-dom";
import { useBgHover } from "../../themes/colors";
import { formatDate } from "../../utils/helperFunction";

interface CategorizedHorizontalBlogCardProps {
  imageSrc: string;
  title: string;
  description: string;
  postDate: string;
  category: string;
  slug: string;
}

const CategorizedHorizontalBlogCard = ({
  imageSrc,
  title,
  description,
  postDate,
  category,
  slug,
}: CategorizedHorizontalBlogCardProps) => {
  const bgHover = useBgHover();
  const navigate = useNavigate();

  const goToDetail = () => {
    navigate(`/blog/${slug}`);
  };

  return (
    <HStack
      alignItems="center"
      gap="16px"
      cursor={"pointer"}
      borderRadius={"md"}
      _hover={{ bg: bgHover }}
      onClick={goToDetail}
    >
      <Image
        src={imageSrc}
        fallbackSrc="/assets/svg/illustration_empty.svg"
        alt={title || "Image"}
        width={{ base: "150px", lg: "200px" }}
        height={{ base: "150px", lg: "200px" }}
        objectFit="cover"
        borderRadius="md"
      />

      <Box>
        <HStack>
          <Icon as={RiInstanceLine} />

          <Text
            // textStyle="h-2xs-gray50"
            textStyle={"b-sm"}
            textTransform={"uppercase"}
            variant={"secondary"}
          >
            {category}
          </Text>
        </HStack>

        <Text
          // textStyle={{ base: "h-xs-primary", lg: "h-sm-primary" }}
          textStyle={"b-reg-sb"}
          noOfLines={2}
          lineHeight={{ base: "16px", lg: "18px" }}
          mt={"10px"}
        >
          {title}
        </Text>

        <Text
          textStyle="b-sm"
          variant={"secondary"}
          noOfLines={3}
          textOverflow={"ellipsis"}
          lineHeight={"12px"}
          mt="10px"
        >
          {description}
        </Text>

        <Text
          textStyle="b-sm"
          variant={"secondary"}
          mt={{ base: "12px", sm: "24px", md: "8px", lg: "32px" }}
        >
          {formatDate(postDate)}
        </Text>
      </Box>
    </HStack>
  );
};

export default CategorizedHorizontalBlogCard;
